import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import {
  Skeleton as AvatarSkeleton,
  Skeleton as HeaderButtonSkeleton,
  Skeleton as HighlightSkeleton,
  Skeleton as PaginationButtonSkeleton,
  Skeleton as PopoverButtonSkeleton,
  Skeleton as TextSkeleton,
} from '@node-space/storybook-components/dist/SkeletonLoader'
import { Box } from '@node-space/ui-components'

interface ActionListSkeletonLoaderProps {
  hasPopoverMenu?: boolean
  rows?: number
  showHeader?: boolean
  showSearchAndFilter?: boolean
  showPagination?: boolean
}

const SEARCH_AND_FILTER_COUNT = 4

const SEARCH_AND_FILTER_WIDTHS = {
  [0]: 'grow',
  [SEARCH_AND_FILTER_COUNT - 1]: 'w-24',
  default: 'w-[180px]',
}

export const ActionListSkeletonLoader = ({
  rows = 5,
  hasPopoverMenu,
  showHeader,
  showSearchAndFilter,
  showPagination,
}: ActionListSkeletonLoaderProps) => {
  return (
    <Box flexCol gap={16}>
      {showHeader && (
        <Box flex justify="between" paddingB={20}>
          <TextSkeleton className="w-1/4" variant="title" />
          <HeaderButtonSkeleton className="w-[180px]" variant="button" />
        </Box>
      )}
      {showSearchAndFilter && (
        <Box flex gap={12} align="center">
          {[...Array(SEARCH_AND_FILTER_COUNT)]?.map((_, index) => (
            <TextSkeleton
              className={SEARCH_AND_FILTER_WIDTHS?.[index] ?? SEARCH_AND_FILTER_WIDTHS.default}
              key={uuidv4()}
              variant="button"
            />
          ))}
        </Box>
      )}
      <Box>
        {[...Array(rows)]?.map(() => (
          <Box key={uuidv4()} paddingX={16} paddingY={16} flex align="center" gapX={12} hasBorder>
            <AvatarSkeleton variant="button" isIcon />
            <Box flexCol gap={8} flexSize="fill">
              <TextSkeleton className="w-40" variant="text" />
              <TextSkeleton className="w-32" variant="text-xs" />
            </Box>
            <HighlightSkeleton className="w-28 rounded-[20px]" variant="title" />
            {hasPopoverMenu && (
              <Box flex justify="center" className="w-10">
                <PopoverButtonSkeleton className="w-2" variant="button" />
              </Box>
            )}
          </Box>
        ))}
      </Box>
      {showPagination && (
        <Box flex justify="between" align="center">
          <TextSkeleton className="w-20" variant="text" />
          <Box flex gapX={24} align="center">
            {[...Array(4)]?.map(() => (
              <PaginationButtonSkeleton key={uuidv4()} variant="title" isIcon />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  )
}
